import './truncate.css';
export default {
  "dirRtl": "pf-v6-m-dir-rtl",
  "modifiers": {
    "fixed": "pf-m-fixed"
  },
  "truncate": "pf-v6-c-truncate",
  "truncateEnd": "pf-v6-c-truncate__end",
  "truncateStart": "pf-v6-c-truncate__start"
};